<template>
    <div ref="navRef" :class="['border-b border-gray-200 bg-white z-20', isSticky ? 'sticky top-0 shadow-md' : '']">
        <div class="container mx-auto px-4">
            <ul class="flex items-center space-x-6 overflow-auto">
                <template v-for="section in items" :key="section.id">
                    <li v-if="section.show" class="px-3">
                        <a href="#" @click.prevent="scrollTo(section.id)" :class="['whitespace-nowrap pt-5 pb-4.5 block border-b-2 transition hover:no-underline', activeId === section.id ? 'border-pink-500 text-pink-500 font-medium' : 'border-transparent text-gray-600']">
                            {{ $t(section.label) }}
                        </a>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useScrollSpy } from '@/composables/useScrollSpy'
import { useScrollToElement } from '@/composables/useScrollToElement'

const props = defineProps({
    items: {
        type: Array,
        required: true
    }
})

const { scrollTo } = useScrollToElement()

// ✅ props are NOT refs → no .value
const sectionIds = computed(() => props.items.filter((s) => s.show).map((s) => s.id))

// ✅ pass the computed ref itself
const { activeId } = useScrollSpy(sectionIds)

// Dynamic sticky behavior
const navRef = ref(null)
const isSticky = ref(false)
let navOffsetTop = 0

onMounted(() => {
    if (navRef.value) {
        navOffsetTop = navRef.value.offsetTop
    }

    const handleScroll = () => {
        if (navRef.value) {
            isSticky.value = window.scrollY >= navOffsetTop
        }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Check initial state

    onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll)
    })
})
</script>
